import coinsPaymentOption from 'client/components/loyalty/CoinsPaymentOption';
import coinsInput from 'client/components/loyalty/CoinsInput';

export default {
    coinsPaymentOption,
    coinsInput
};
